export const API_RESET_PASSWORD="/identity/users/reset-password"
